import { render, staticRenderFns } from "./PreLoginLanguageSelector.vue?vue&type=template&id=60b70b04&scoped=true"
import script from "./PreLoginLanguageSelector.vue?vue&type=script&lang=js"
export * from "./PreLoginLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./PreLoginLanguageSelector.vue?vue&type=style&index=0&id=60b70b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0_supports-_8222eee745b2e984d0467402f7084607/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b70b04",
  null
  
)

export default component.exports